import moment from 'moment'
import { useEffect, useCallback, useState } from 'react'

/* eslint-disable no-bitwise */
export function arrayConverter(arrayBuffer) {
  let base64 = ''
  const encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

  const bytes = new Uint8Array(arrayBuffer)
  const { byteLength } = bytes
  const byteRemainder = byteLength % 3
  const mainLength = byteLength - byteRemainder

  let a
  let b
  let c
  let d
  let chunk

  // Main loop deals with bytes in chunks of 3
  for (let i = 0; i < mainLength; i += 3) {
    // Combine the three bytes into a single integer
    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

    // Use bitmasks to extract 6-bit segments from the triplet
    a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
    b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
    c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
    d = chunk & 63 // 63       = 2^6 - 1

    // Convert the raw binary segments to the appropriate ASCII encoding
    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
  }

  // Deal with the remaining bytes and padding
  if (byteRemainder === 1) {
    chunk = bytes[mainLength]

    a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

    // Set the 4 least significant bits to zero
    b = (chunk & 3) << 4 // 3   = 2^2 - 1

    base64 += `${encodings[a]}${encodings[b]}==`
  } else if (byteRemainder === 2) {
    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

    a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
    b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

    // Set the 2 least significant bits to zero
    c = (chunk & 15) << 2 // 15    = 2^4 - 1

    base64 += `${encodings[a]}${encodings[b]}${encodings[c]}=`
  }

  return base64
}

export const formatDate = date => moment(date).format('dddd, Do MMM YYYY, HH:mm')

/**
 * Adds event listener to a given element.
 *
 * @param {HTMLElement} element Element to attach the listener to
 * @param {string} type Event type
 * @param {Function} listener Event listener
 */
function useEventListener(element, type, listener) {
  useEffect(() => {
    if (!element) {
      return undefined
    }

    element.addEventListener(type, listener)

    return () => {
      element.removeEventListener(type, listener)
    }
  }, [element, type, listener])
}

/**
 * Returns the interior width of the window in pixels.
 *
 * @returns {number} Width of the window in pixels
 */
export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  // const [previewPDFWidth, setpreviewPDFWidth] = useState(window.innerWidth)

  const getWindowWidth = useCallback(() => setWindowWidth(window.innerWidth), [])
  /*   const getPreviewPDFWidth = useCallback(
    () => setpreviewPDFWidth(document.getElementsByClassName('previewPDF')[0].offsetWidth || 10),
    [],
  ) */

  useEventListener(window, 'resize', getWindowWidth)
  // useEventListener(document, 'DOMContentLoaded', getPreviewPDFWidth())

  // console.log('previewPDFWidth', previewPDFWidth)
  console.log('windowWidth', windowWidth * 0.4)

  return windowWidth
}

export function useRowWith() {}

// Generate Images from thumbnails base64
export const generateImages = array => array.map(thumbnail => arrayConverter(thumbnail.data))

// Convert bytes to MB for files size
export const bytesToKiloBytes = bytes => (bytes / 1024).toFixed(2)

export const bytesToMegaBytes = bytes => (bytes / (1024 * 1024)).toFixed(2)
